
(function () {
  'use strict';

  var LAST_BOOKING_FEE_PROP = ' Last-minute booking fee';
  var LAST_BOOKING_FEE_VAL  = '50$ (+ $50.00)';
  var BOOKING_DATE_PROP     = ' Booking date ';

  if (!window.BssAddonOnce) {
    window.BssAddonOnce = {
      hasAddon: false, addonLineKey: null, ready: false, _pendingRushDate: null,
      _callbacks: [],
      onReady: function (fn) { this.ready ? fn() : this._callbacks.push(fn); },
      _resolve: function () {
        this.ready = true;
        this._callbacks.forEach(function (fn) { fn(); });
        this._callbacks = [];
      }
    };
  }
  function parseDateInput(dateValue) {
    if (!dateValue) return null;
    var s = String(dateValue).trim();
    if (s.indexOf('/') !== -1) {
      var p = s.split('/');
      if (p.length === 3) {
        var d1 = new Date(parseInt(p[2]), parseInt(p[1]) - 1, parseInt(p[0]));
        if (!isNaN(d1.getTime()) && d1.getDate() === parseInt(p[0])) return d1;
        var d2 = new Date(parseInt(p[2]), parseInt(p[0]) - 1, parseInt(p[1]));
        if (!isNaN(d2.getTime())) return d2;
      }
    }
    if (s.indexOf('-') !== -1) {
      var p = s.split('-');
      if (p.length === 3) {
        if (p[0].length === 4) {
          var d = new Date(parseInt(p[0]), parseInt(p[1]) - 1, parseInt(p[2]));
          if (!isNaN(d.getTime())) return d;
        }
        if (p[2].length === 4) {
          var d = new Date(parseInt(p[2]), parseInt(p[0]) - 1, parseInt(p[1]));
          if (!isNaN(d.getTime())) return d;
        }
      }
    }
    var d = new Date(s);
    return isNaN(d.getTime()) ? null : d;
  }

  function formatDateShort(d) {
    var mm = String(d.getMonth() + 1).padStart(2, '0');
    var dd = String(d.getDate()).padStart(2, '0');
    return mm + '-' + dd + '-' + d.getFullYear();
  }

  function getProp(props, name) {
    if (props[name] !== undefined) return props[name];
    if (props[' ' + name] !== undefined) return props[' ' + name];
    if (props[name.trim()] !== undefined) return props[name.trim()];
    return undefined;
  }

  function itemHasAddon(item) {
    var fee = getProp(item.properties || {}, 'Last-minute booking fee');
    return fee !== undefined && String(fee).indexOf('50$') !== -1;
  }
  function itemIsRushEligible(item) {
    var props = item.properties || {};
    var bookingDate = getProp(props, 'Booking date ') || getProp(props, 'Booking date');
    if (!bookingDate) return false;
    var parts = String(bookingDate).split(' - ');
    if (parts.length !== 2) return false;
    var weddingDate = parseDateInput(parts[0].trim());
    var orderDate   = parseDateInput(parts[1].trim());
    if (!weddingDate || !orderDate) return false;
    weddingDate.setHours(0,0,0,0);
    orderDate.setHours(0,0,0,0);
    return weddingDate.getTime() < orderDate.getTime();
  }

  function syncState(cart) {
    var items = cart.items || [];
    for (var i = 0; i < items.length; i++) {
      if (itemHasAddon(items[i])) {
        window.BssAddonOnce.hasAddon     = true;
        window.BssAddonOnce.addonLineKey = items[i].key;
        return;
      }
    }
    window.BssAddonOnce.hasAddon     = false;
    window.BssAddonOnce.addonLineKey = null;
  }

  function fetchCart(cb) {
    fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cb(null, c); })
      .catch(function (e) { cb(e, null); });
  }

  var _assigningAddon = false;
  function assignAddon(lineKey, existingProps, callback) {
    if (_assigningAddon) return;
    _assigningAddon = true;

    var newProps = Object.assign({}, existingProps);
    newProps[LAST_BOOKING_FEE_PROP] = LAST_BOOKING_FEE_VAL;
    newProps['__bss_po_addons']     = '50';
    var customAttrs = Object.assign({}, newProps);
    delete customAttrs['_bssPrice'];
    delete customAttrs['_bssCustomAttributes'];
    delete customAttrs['_bssVariants'];
    newProps['_bssPrice']           = JSON.stringify({ extra: 50 });
    newProps['_bssCustomAttributes'] = JSON.stringify(customAttrs);
    newProps['_bssVariants']        = '{}';

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, properties: newProps })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        _assigningAddon = false;
        console.log('[BssAddonOnce] assignAddon done — key:', lineKey);
        if (typeof callback === 'function') callback(null);
      })
      .catch(function (e) {
        console.error('[BssAddonOnce] assignAddon failed', e);
        _assigningAddon = false;
        if (typeof callback === 'function') callback(e);
      });
  }

  function reassignAddon(cart) {
    var items = cart.items || [];
    for (var i = 0; i < items.length; i++) {
      if (itemIsRushEligible(items[i])) {
        console.log('[BssAddonOnce] Reassigning addon to:', items[i].key);
        assignAddon(items[i].key, items[i].properties || {}, function (err) {
          if (!err) location.reload();
        });
        return;
      }
    }
    window.BssAddonOnce.hasAddon     = false;
    window.BssAddonOnce.addonLineKey = null;
  }

  function onCartUpdate(cart) {
    if (!cart || !Array.isArray(cart.items)) return;
    var prevHasAddon = window.BssAddonOnce.hasAddon;
    syncState(cart);

    if (prevHasAddon && !window.BssAddonOnce.hasAddon) {
      reassignAddon(cart);
    }
  }

  function watchCart() {
    function trySubscribe() {
      if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
        window.MinimogEvents.subscribe(window.MinimogTheme.pubSubEvents.cartUpdate, onCartUpdate);
      } else {
        setTimeout(trySubscribe, 300);
      }
    }
    trySubscribe();
  }
  var PRODUCT_CONFIGS = [
    {
      datepickerId:    'datetime546601',
      checkboxName:    'po_checkbox1405937',
      bookingInputId:  'po_text_box1405939',
      bookingInputName:'po_text_box1405939',
      optionSetID:     221846,
      optionID:        1405939,
    },
    {
      datepickerId:    'datetime578885',
      checkboxName:    'po_checkbox1405974',
      bookingInputId:  'po_text_box1405975',
      bookingInputName:'po_text_box1405975',
      optionSetID:     228057,
      optionID:        1405975,
    },
  ];

  function updateBookingDate(weddingDate, cfg) {
    var bookingInput = document.getElementById(cfg.bookingInputId);
    if (!bookingInput) bookingInput = document.querySelector('input[name="' + cfg.bookingInputName + '"]');
    if (!bookingInput) return;

    var today = new Date();
    var range = formatDateShort(weddingDate) + ' - ' + formatDateShort(today);
    bookingInput.value = range;
    bookingInput.dispatchEvent(new Event('input', { bubbles: true }));
    bookingInput.dispatchEvent(new Event('change', { bubbles: true }));

    if (typeof BSS_PO !== 'undefined' && BSS_PO.po && typeof BSS_PO.po.handleChangeValue === 'function') {
      BSS_PO.po.handleChangeValue({
        selector: bookingInput,
        optionType: 'text_box',
        appliedOptionSetID: cfg.optionSetID,
        optionID: cfg.optionID,
        labelOnProduct: 'Booking date ',
        maxSelector: 1,
        position: 0,
        optionSetConditionType: 1
      });
    }

    console.log('[BssAddonOnce] Booking date:', range);
  }

  function watchOnePicker(cfg) {
    function tryWatch() {
      var dpInput = document.getElementById(cfg.datepickerId);
      if (!dpInput) { setTimeout(tryWatch, 500); return; }

      var lastValue = '';

      function onDateSelected() {
        var selectedDate = dpInput.value;
        if (!selectedDate || selectedDate === lastValue) return;
        lastValue = selectedDate;
        var parsed = parseDateInput(selectedDate);
        if (!parsed) return;

        updateBookingDate(parsed, cfg);

        var today = new Date(); today.setHours(0, 0, 0, 0);
        var cmp   = new Date(parsed); cmp.setHours(0, 0, 0, 0);
        var diffDays = (today.getTime() - cmp.getTime()) / 86400000;
        var isRush = diffDays >= 1 && diffDays <= 7;

        var checkbox = document.querySelector('input[name="' + cfg.checkboxName + '"]');
        if (!checkbox) return;
        if (isRush && !window.BssAddonOnce.hasAddon && !checkbox.checked) {
          checkbox.checked = true;
          checkbox.dispatchEvent(new Event('change', { bubbles: true }));
        } else if (!isRush && checkbox.checked) {
          checkbox.checked = false;
          checkbox.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      dpInput.addEventListener('change', onDateSelected);
      dpInput.addEventListener('input', onDateSelected);

      var pollInterval = setInterval(function () {
        if (dpInput.value !== lastValue) onDateSelected();
      }, 300);

      window.addEventListener('beforeunload', function () { clearInterval(pollInterval); });
      if (dpInput.value) setTimeout(onDateSelected, 500);

      console.log('[BssAddonOnce] watchDatePicker ready:', cfg.datepickerId);
    }
    tryWatch();
  }

  function watchDatePicker() {
    PRODUCT_CONFIGS.forEach(function (cfg) { watchOnePicker(cfg); });
  }

  watchDatePicker();

  fetchCart(function (err, cart) {
    if (!err && cart) {
      syncState(cart);
      if (!window.BssAddonOnce.hasAddon) {
        var items = cart.items || [];
        for (var i = 0; i < items.length; i++) {
          if (itemIsRushEligible(items[i])) {
            assignAddon(items[i].key, items[i].properties || {}, function (err) {
              if (!err) location.reload();
            });
            break;
          }
        }
      }
    }
    window.BssAddonOnce._resolve();
    watchCart();
  });

})();
